export default __webpack_public_path__ + "static/media/map.a9191ee9.svg";